import { constants, selectors } from '@yola/subscription-manager-js';
import store from 'src/js/store';
import isDifmOrderSubmitted from 'src/js/modules/difm/verifiers/is-difm-order-submitted';

const {
  SubscriptionType: { B2C_HOSTING_GOLD },
} = constants;

const isLimitedOfferAvailable = () => {
  const state = store.getState();
  const isOrderSubmitted = isDifmOrderSubmitted();
  const currentPlan = selectors.getCurrentPackageType(state);
  const isGold = currentPlan === B2C_HOSTING_GOLD;
  const difmOrderSubmittedWithExpiredGold = !isGold && isOrderSubmitted;

  return !difmOrderSubmittedWithExpiredGold && !isGold;
};

export default isLimitedOfferAvailable;
